<script >
	import { onMount } from 'svelte';
	import Footer from "../../WebSite/Footer.svelte";
	import Nav from "../../WebSite/Nav.svelte";
	import AppNav from "./AppNav/index.svelte";
	import AppContent from "./AppContent/index.svelte";
	import AppInfo from "./AppInfo/index.svelte";
	import {setState, getState} from "../../../stores.js";

	let companyName = null;


	onMount(() => {

		let user = localStorage.getItem('user');

		user = JSON.parse(user);

		companyName = user.company;

	});

	/* appState - Defines the page that is shown on AppContent
		
		state 0 - Company Info
		state 1 - Products
		state 2 - Batch Data
		state 3 - User Info
		state 4 - Data analysis

		default State : 0
	*/

	let appState = getState('appState') || 0;
	let colabList = null;

	export let batchFilter = null;
	export let addNewBatch = getState('addNewBatch') || false;;

</script>



<Nav changeNavElement={false} isUserLogedIn={true}/>
<main id="main">
	
	<div class="dashboardContainer">

		<div class="dashboardColumn firstColumn">
			<AppNav bind:navSelected={appState} />
		</div>
		

		<div class="dashboardColumn secondColumn">
			<AppContent bind:addNewBatch={addNewBatch} navSelected={appState} bind:colabList={colabList} batchFilter={batchFilter}/>
		</div>

		{#if (appState == 0 && companyName == 'none') ||  (appState == 4 )  }
			<div class="dashboardColumn thirdColumnClosed">

			</div>
		{:else}
			<div class="dashboardColumn thirdColumn">
				<AppInfo addNewBatch={addNewBatch} navSelected={appState} colaboratorsList={colabList} bind:batchFilter={batchFilter}/>
			</div>
		{/if}
		

		
	</div>

	<Footer/>
</main>


<style>

	:root{
		--brand-base:#FFD7B6;
		--brand: #ff8722;
		--brand-accent:#2199FF;
		--app-nav-web-color:var(--brand);
		--app-nav-web-text-color: white;
		--app-nav-color: white;
		--logo-color: var(--brand);		
	}

	/*for mobile*/

	@media only screen and (max-width: 600px) {
	
	main {
		width:100%;
		height:100%;
		background-color: white;
		display: block;
		overflow: scroll;
		overflow-x: hidden;
		scrollbar-width: none;
		/*scroll-snap-type: none;*/
		position: relative;
	}

	main::-webkit-scrollbar {
		width: 0em;
	}

	.dashboardContainer{
		width:100vw;
		height:30vh;
		background-color: white;
		display: flex;
		flex-direction: row;

		scroll-snap-align: start;
	}



	}

		

	@media only screen and (min-width: 768px) {

		main {
			width:100%;
			height:100%;
			background-color: white;
			display: block;
			overflow: scroll;
			overflow-x: hidden;
			scrollbar-width: none;
			scroll-snap-type: y;
			position: relative;
			

		}

		main::-webkit-scrollbar {
			width: 0em;
		}

		.dashboardContainer{
			width:100vw;
			height:90.9vh;
			background-color: white;
			display: flex;
			flex-direction: row;
			scroll-snap-align: start;
			


		}

		.dashboardColumn{
			height: 100%;
			background-color: #1F1F1F;
			/*background-color: white;*/
			
			display: flex;
			flex-direction: column;
		}


		/*	AppNav		*/

		.firstColumn{
			width: 15%;
			background-color: var(--brand);

		}	

		/*	AppContent	*/

		.secondColumn{
			width: 65%;
			background-color: white;
			flex-grow: 1;
		}

		
		/*	AppInfo		*/

		.thirdColumn{
			width: 20%;
			background-color: white;
		}

		.thirdColumnClosed{
			width: 0%;
			background-color: darkcyan;
		}
		
		
	}
</style>